import { IContainer } from '../../interface/container';
import { injectModelInstantiator } from '../../model/interface/bind';
import { IDBOptions, IWorkspaceDBInstantiator } from '../interface/instantiator';
import instantiator from './instantiator';

function bind(container: IContainer): IWorkspaceDBInstantiator {
    const modelInstantiator = injectModelInstantiator(container);

    return {
        open: (options: IDBOptions) => instantiator(modelInstantiator, options),
    };
}

export default bind;
